
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/components/AuthProvider';
import { toast } from 'sonner';
import { useLanguage } from '@/components/LanguageContext';

export const useSendMessage = (channelId?: string, recipientId?: string) => {
  const [sending, setSending] = useState(false);
  const { user } = useAuth();
  const { t } = useLanguage();

  const sendMessage = async (content: string) => {
    if (!user) {
      toast.error(t('messages.authRequired'));
      return;
    }
    
    if (!content.trim()) {
      return;
    }
    
    if (!channelId && !recipientId) {
      toast.error(t('messages.noRecipient'));
      return;
    }

    try {
      setSending(true);
      
      const messageData = {
        content: content.trim(),
        sender_id: user.id,
        channel_id: channelId || null,
        recipient_id: recipientId || null
      };
      
      
      
      const { error } = await supabase
        .from('messages')
        .insert(messageData);

      if (error) {
        console.error('Error sending message:', error);
        toast.error(t('messages.errorSending'));
      }
    } catch (error) {
      console.error('Error in sendMessage:', error);
      toast.error(t('messages.errorSending'));
    } finally {
      setSending(false);
    }
  };

  return { sendMessage, sending };
};
